document.addEventListener('DOMContentLoaded', function() {
    const swiper = new Swiper('.swiper', {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: true,
        centeredSlides: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
                spaceBetween: 12,
                loop: true,
                centeredSlides: false,
            },
            1150: {
                slidesPerView: 3,
                spaceBetween: 12,
                loop: true,
                centeredSlides: true,
            },
            1200: {
                slidesPerView: 4,
                spaceBetween: 12,
                centeredSlides: false,
            },
            1440: {
                slidesPerView: 4,
                spaceBetween: 12,
                centeredSlides: false,
            }
        }
    });
});